export const GENDER_COLOURS = {
  Boys: "#3b82f6",
  Girls: "#ec4899",
  Mixed: ["#ec4899", "#3b82f6"],
};

export const OFSTED_BORDER_COLOURS = {
  Outstanding: "#166534",
  Good: "#60a5fa",
  "Requires improvement": "#f59e0b",
  Inadequate: "#dc2626",
};

export const OFSTED_DEFAULT_BORDER = "#94a3b8";

/** DB / filters may use title case; pin assets use sentence case for RI. */
export function normaliseOfstedGradeForPin(grade) {
  const g = String(grade || "").trim();
  if (!g) return "";
  const lower = g.toLowerCase();
  if (lower === "outstanding") return "Outstanding";
  if (lower === "good") return "Good";
  if (lower === "requires improvement" || lower === "requiresimprovement") {
    return "Requires improvement";
  }
  if (lower === "inadequate") return "Inadequate";
  return g;
}

export const PIN_WIDTH = 30;
export const PIN_HEIGHT = 40;
export const PIN_HEAD_R = 12;
/** White separator between gender fill and Ofsted ring */
export const HALO_COLOUR = "#ffffff";
export const HALO_STROKE_WIDTH = 4;
export const OFSTED_STROKE_WIDTH = 3;
/** Inset of gender fill inside the border path (creates white gap before halo) */
export const FILL_INSET = 1.5;
export const FONT_SIZE = 13;
export const STAR_SIZE = 9;
export const STAR_COLOUR = "#eab308";
